// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQ_wrapper__QNJLw","accordion":"FAQ_accordion__j7487","faqText":"FAQ_faqText__2GNV0"};